import StreamPreview from "@/components/StreamPreview";
import AuthContext from "@/context/auth";
import getPublicUrl from "@/libs/get-public-url";
import { streamsStore } from "@/libs/stores/streams.store.ts";
import { Box, Flex, Grid, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

const GroupTitle = ({ name }) => {
  const { user } = useContext(AuthContext);
  return (
    <Flex
      justify="space-between"
      fontWeight="bold"
      color="white"
      align="center"
      as={motion.div}
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.3, ease: "easeOut" }}
    >
      <Text
        fontSize="xl"
        maxW="80%"
        sx={{
          wordBreak: "break-word",
          whiteSpace: "pre-wrap",
        }}
      >
        {name}
      </Text>
    </Flex>
  );
};

const LiveStreamsGroup = observer(({ name = "直播中" }) => {
  const navigate = useNavigate();
  const streams = streamsStore.streams;
  const initialLoading = streamsStore.loading;

  const onStreamClick = (streamIndex) => () => {
    const stream = streams[streamIndex];
    if (stream?.slug) {
      navigate(`/s/@${stream.slug}`);
    }
  };

  if (initialLoading) {
    return (
      <Box mt={4} pl={2}>
        <GroupTitle name={name} />
        <Text color="gray.400" mt={4}>載入直播中...</Text>
      </Box>
    );
  }

  if (!streams.length) {
    return null;
  }

  return (
    <Box mt={4} pl={2}>
      <GroupTitle name={name} />
      <Grid
        as={motion.div}
        initial={{ x: 100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        templateColumns="repeat(3, 1fr)"
        gap={3}
        my={6}
        pr={6}
      >
        {streams.map((stream, index) => {
          if (!stream) return null;
          return (
            <Box
              key={`stream-${stream.id || stream.streamId}-${index}`}
            >
              <StreamPreview
                index={index}
                onClick={onStreamClick(index)}
                title={stream.title}
                avatarUrl={getPublicUrl(stream.creatorAvatarUrl)}
                creatorName={stream.creatorName}
                streamId={stream.streamId}
                mode={stream.mode}
                popularity={stream.popularity}
              />
            </Box>
          );
        })}
      </Grid>
    </Box>
  );
});

export default LiveStreamsGroup; 